// @flow

import {createSelector} from 'reselect'

const selectAccessibilityState = (state) => state.get('accessibility');

export const selectFontSize = createSelector(
  [selectAccessibilityState],
  (accessibilityState) => accessibilityState.get('fontSize')
);


// WEBPACK FOOTER //
// ./src/modules/accessibility/store/selectors.js